import * as React from 'react';
import MenuLink from './MenuLink';
import * as Moment from 'moment-timezone';
import { ClockAccuracyReport } from './Timer/ClockAccuracyReport';
import * as Utils from './Utils';

export interface INavbarState {
  offsetSec?: number
}

const CLOCK_URL = "https://worldtimeapi.org/api/timezone/Etc/UTC";

export default class Navbar extends React.Component<{}, INavbarState> {

  constructor(props: {}) {
    super(props);
    this.state = {
      offsetSec: undefined
    }
    this.refreshClockDiff = this.refreshClockDiff.bind(this);
  }

  public render() {

    return (
      <nav className="fixed-top navbar navbar-expand-lg navbar-light bg-light mb-2">
        <a className="navbar-brand" href="#">
          <img src="/favicon.ico" width="30" height="30" className="d-inline-block align-top" alt="Clock icon" />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <MenuLink to="/calculator" label="Calculator" />
            <MenuLink to="/timer" label="Timer" />
            <MenuLink to="/doomsday" label="Doomsday" />
          </ul>
          <div className="w-100 text-right">
            <ClockAccuracyReport offsetSec={this.state.offsetSec} />
          </div>
        </div>
      </nav>
    );
  }

  public async componentDidMount() {
    Utils.setRefreshClockDiff(this.refreshClockDiff);
    this.refreshClockDiff();
  }

  private async refreshClockDiff() {
    try {
      const resp = await fetch(CLOCK_URL);
      const json = (await resp.json()) as {
        datetime: string;
      };
      const internetTime = Moment.utc(json.datetime);
      const currentTime = Moment();
      const offsetSec = currentTime.diff(internetTime, 'seconds');
      this.setState({
        offsetSec
      });
      return offsetSec;
    } catch (e) {
      throw e;
    }
  }
}


// WEBPACK FOOTER //
// ./src/Navbar.tsx